/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { WorkflowNode } from './workflow-node';

export class WorkflowLoopNode extends WorkflowNode {
    property: string;
    propertyLabel: string;
    nextNode: WorkflowNode;
}
